<div class="tw-flex tw-gap-1 tw-items-center">
  @for(method of paymentMethods; track $index) {
  <img class="tw-h-7 tw-rounded-sm" [alt]="method.name" [title]="method.name"
    [src]="'/assets/images/payment-logo/' + method.logo + '.jpg'">
  }
</div>